/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Change_Preview_FailedInputs */

const en_plan_change_preview_failed = /** @type {(inputs: Plan_Change_Preview_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not work out what this change would cost.`)
};

const es_plan_change_preview_failed = /** @type {(inputs: Plan_Change_Preview_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos calcular cuánto costaría este cambio.`)
};

/**
* | output |
* | --- |
* | "We could not work out what this change would cost." |
*
* @param {Plan_Change_Preview_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_preview_failed = /** @type {((inputs?: Plan_Change_Preview_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_Preview_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_preview_failed(inputs)
	return en_plan_change_preview_failed(inputs)
});